import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["action"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export function setExperiencesForwarding(fromExperienceTracker, toExperienceTracker) {
  if (!fromExperienceTracker || !toExperienceTracker) {
    return;
  }
  var cancelExperiencesForwarding = fromExperienceTracker.subscribe(function (_ref) {
    var action = _ref.action,
      options = _objectWithoutProperties(_ref, _excluded);
    switch (action) {
      case 'taskAbort':
        toExperienceTracker.abort(_objectSpread(_objectSpread({}, options), {}, {
          checkForTimeout: false // disallow `taskAbort` to be converted into `taskFail`
        }));
        break;
      case 'taskFail':
        toExperienceTracker.fail(options);
        break;
      case 'taskStart':
        toExperienceTracker.start(options);
        break;
      case 'taskSuccess':
        toExperienceTracker.succeed(options);
        break;
    }
  });
  return cancelExperiencesForwarding;
}